module.exports = __webpack_public_path__ + "2e45d9d2e9e29cb544907f7e00047fb6.jpg";